import createVueI18nInstance from "@rmp/core/plugins/i18n";

const i18n = createVueI18nInstance({});

export default i18n;
